import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "modal-dialog modal-dialog-centered",
  role: "document"
}
const _hoisted_2 = { class: "modal-content" }
const _hoisted_3 = { class: "modal-header" }
const _hoisted_4 = { class: "d-flex align-items-center gap-2" }
const _hoisted_5 = { class: "modal-title mb-0" }
const _hoisted_6 = { class: "modal-body" }

import { ref } from 'vue'
import { Modal } from 'bootstrap'
import VehicleForm from './VehicleForm.vue'
import VehicleRepository from '@/repositories/VehicleRepository'
import StorageService from '@/services/StorageService'
import ToastService from '@/services/ToastService'
import i18n from '@/plugins/i18n'

interface CreateVehiclePayload {
  plate: string
  brand: string
  model: string
  color: { name: string; hex: string }
  soat_exp?: string
  tec_exp?: string
}


export default /*@__PURE__*/_defineComponent({
  __name: 'VehicleCreateModal',
  emits: ["created"],
  setup(__props, { expose: __expose, emit: __emit }) {

const emit = __emit

const modalEl = ref<HTMLElement | null>(null)
let modalInstance: Modal | null = null

const currentPlate = ref<string>('')

function open(plate?: string): void {
  currentPlate.value = plate ?? ''
  const el = modalEl.value
  if (!el) return
  modalInstance = Modal.getOrCreateInstance(el)
  modalInstance.show()
}

__expose({ open })

async function onFormSubmit(payload: CreateVehiclePayload, file: File | null): Promise<void> {
  try {
    const vehicle = await VehicleRepository.create(payload)
    if (file) {
      try {
        const storageRef = StorageService.getStorageReference(StorageService.vehiclePath, vehicle.id, file.name)
        const url = await StorageService.uploadFile(storageRef, file)
        await VehicleRepository.update(vehicle.id, { photoUrl: url })
      } catch (uploadErr: unknown) {
        const err = uploadErr as { message?: string }
        await ToastService.toast(ToastService.ERROR, i18n.global.t('common.messages.error'), err.message)
      }
    }
    emit('created', vehicle.id)
    modalInstance?.hide()
  } catch (e: unknown) {
    const axiosErr = e as { response?: { status?: number; data?: { data?: { vehicle_id?: string } } } }
    if (axiosErr?.response?.status === 409) {
      const vehicleId = axiosErr.response?.data?.data?.vehicle_id
      if (vehicleId) {
        emit('created', vehicleId)
        modalInstance?.hide()
        return
      }
    }
    const err = e as { message?: string }
    await ToastService.toast(ToastService.ERROR, i18n.global.t('common.messages.error'), err.message)
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "modal fade",
    id: "vehicle-create-modal",
    ref_key: "modalEl",
    ref: modalEl,
    tabindex: "-1",
    "aria-hidden": "true"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _cache[0] || (_cache[0] = _createElementVNode("span", { class: "vehicle-modal-icon-chip" }, [
              _createElementVNode("em", { class: "fas fa-car" })
            ], -1)),
            _createElementVNode("h5", _hoisted_5, _toDisplayString(_ctx.$t('vehicles.forms.create')), 1)
          ]),
          _cache[1] || (_cache[1] = _createElementVNode("button", {
            type: "button",
            class: "btn-close",
            "data-bs-dismiss": "modal",
            "aria-label": "Close"
          }, null, -1))
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(VehicleForm, {
            "initial-plate": currentPlate.value,
            onSubmit: onFormSubmit
          }, null, 8, ["initial-plate"])
        ])
      ])
    ])
  ], 512))
}
}

})